import { axios } from "@app/app/services/axios";
import { IPropertyGroup, IPropertyMapData } from "@app/propertyGroup/types";

export const getPropertyGroup = async (propertyGroupId: string, page: number, filters?: string[]): Promise<IPropertyGroup> => {
    const params = new URLSearchParams();
    params.append("page", page.toString());

    if (filters && filters.length > 0) {
        filters.forEach((filterId) => {
            params.append("filters[]", filterId);
        });
    }

    const response = await axios.get<IPropertyGroup>(`/property_groups/${propertyGroupId}?${params.toString()}`);

    return response.data;
};

export const getPropertiesForMap = async (
    propertyGroupId: string,
    propertyIds: string[],
    filterMode: "any" | "all" = "all",
    filters?: string[],
    withRates = false
): Promise<IPropertyMapData[]> => {
    const params = new URLSearchParams();
    params.append("filter_mode", filterMode);

    propertyIds.forEach((propertyId) => {
        params.append("property_ids[]", propertyId);
    });

    if (filters && filters.length > 0) {
        filters.forEach((filterId) => {
            params.append("filters[]", filterId);
        });
    }

    const response = await axios.get<IPropertyMapData[]>(
        `/property_groups/${propertyGroupId}/map?with_rates=${withRates}&${params.toString()}`
    );

    return response.data;
};
